import * as React from 'react';

function SvgCompleteBook(props) {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20.625 4.313h-3.938v-1.5a.188.188 0 00-.187-.188h-1.313a.188.188 0 00-.187.188v1.5H9v-1.5a.188.188 0 00-.188-.188H7.5a.188.188 0 00-.188.188v1.5H3.376a.75.75 0 00-.75.75v15.562c0 .415.335.75.75.75h17.25a.75.75 0 00.75-.75V5.062a.75.75 0 00-.75-.75zm-4.348 5.828l-4.983 6.86a.377.377 0 01-.609 0l-2.962-4.078a.188.188 0 01.152-.297h1.294a.38.38 0 01.304.155l1.517 2.085 3.537-4.87a.377.377 0 01.304-.155h1.294c.152.003.241.176.152.3z"
        fill="#38B2A6"
      />
    </svg>
  );
}

export default SvgCompleteBook;
